import { render, staticRenderFns } from "./LessonNoteLayout.vue?vue&type=template&id=6248f09d&scoped=true&"
import script from "./LessonNoteLayout.vue?vue&type=script&lang=js&"
export * from "./LessonNoteLayout.vue?vue&type=script&lang=js&"
import style0 from "./LessonNoteLayout.vue?vue&type=style&index=0&id=6248f09d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6248f09d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VAppBar,VAppBarNavIcon,VDivider,VImg,VMain,VNavigationDrawer,VSpacer})
